import { render, staticRenderFns } from "./CustomerCrmVamTypeSettings.vue?vue&type=template&id=22fb2a00&scoped=true&"
import script from "./CustomerCrmVamTypeSettings.vue?vue&type=script&lang=js&"
export * from "./CustomerCrmVamTypeSettings.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCrmVamTypeSettings.vue?vue&type=style&index=0&id=22fb2a00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fb2a00",
  null
  
)

export default component.exports